import { queryOptions } from "@tanstack/react-query";
import { listScriptReviewRejections } from "@/features/script-review/api/script-review-rejections.api";

export const scriptReviewRejectionKeys = {
  all: ["script-review-rejections"] as const,
  list: () => [...scriptReviewRejectionKeys.all, "list"] as const,
};

/**
 * Open prompt-improvement tickets (Adge-admin section). Polls lightly while any
 * ticket is still PENDING (the worker is drafting its suggestion), then stops.
 */
export function scriptReviewRejectionsQueryOptions() {
  return queryOptions({
    queryKey: scriptReviewRejectionKeys.list(),
    queryFn: () => listScriptReviewRejections(),
    refetchInterval: (query) =>
      query.state.data?.items.some((i) => i.status === "PENDING") ? 5000 : false,
    meta: { skipGlobalError: true },
  });
}
